var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInconYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1812 5.31458C36.9731 4.53505 36.5642 3.8237 35.9954 3.25141C35.4266 2.67913 34.7178 2.2659 33.9396 2.05292C31.0812 1.28125 19.6146 1.28125 19.6146 1.28125C19.6146 1.28125 8.14792 1.28125 5.28958 2.05292C4.51135 2.2659 3.80252 2.67913 3.23374 3.25141C2.66497 3.8237 2.25611 4.53505 2.04792 5.31458C1.28125 8.19458 1.28125 14.1979 1.28125 14.1979C1.28125 14.1979 1.28125 20.2012 2.04792 23.0812C2.25586 23.8611 2.6646 24.5728 3.23339 25.1454C3.80219 25.718 4.51115 26.1315 5.28958 26.3446C8.14958 27.1146 19.6146 27.1146 19.6146 27.1146C19.6146 27.1146 31.0812 27.1146 33.9396 26.3446C34.718 26.1315 35.427 25.718 35.9958 25.1454C36.5646 24.5728 36.9733 23.8611 37.1812 23.0812C37.9479 20.2046 37.9479 14.1979 37.9479 14.1979C37.9479 14.1979 37.9479 8.19458 37.1812 5.31458ZM15.8646 19.6496V8.74792L25.4479 14.1996L15.8646 19.6496Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.5625,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInconYoutube);
export default __webpack_public_path__ + "static/media/incon_youtube.6cfbcd9504c4009ba05211dd08c0c93e.svg";
export { ForwardRef as ReactComponent };